import { useQuery } from '@tanstack/react-query';
import {
  getCountries,
  getProductTypeEnablement,
  type CountryEntry,
  type ProductTypeEnablement,
} from './api';

/**
 * Fetch the country catalog from the backend (the strategy registry narrowed
 * by the admin Settings "Target markets" dials). Cached aggressively — the
 * list only changes when an operator flips a dial, so a long staleTime keeps
 * UI snappy across pages. Powers the country picker on every agent dispatch
 * form, product-creation step 2, and the company-account market list.
 *
 * ``productType`` scopes the list to that category's admin-checked countries
 * ('combination' = the union). Omitted = the union across all types.
 */
export function useCountries(productType?: string | null) {
  return useQuery<CountryEntry[]>({
    queryKey: ['countries', productType ?? 'all'],
    queryFn: () => getCountries(productType),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}

/** Which product categories the creation page should offer (admin dial). */
export function useProductTypeEnablement() {
  return useQuery<ProductTypeEnablement>({
    queryKey: ['product-types'],
    queryFn: getProductTypeEnablement,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
